import React,{useState} from "react";
import OfferingCard from "../../components/offerings/OfferingCard";
import OfferingLast from "../../components/offerings/OfferingLast";

import Popup from "../../components/popup/Popup";
import { images } from "../../assets";

function Offerings() {

  const [showPopup, setShowPopup] = useState(false);

  // Function to toggle the visibility of the pop-up form
  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const data = [
    {
      id: 1,
      name: "The Impact league",
      detail:
        "Get your employees healthier and happier with our fun fitness kindness programs - Impact Leagues. Leagues are crafted and customized for you to meet your unique needs. Book a demo to know more.",
      img: images.offering1,
      logo1:images.hdfcBank,
      logo2:images.heroMotor,
      logo3:images.apollo,
      logo4:images.aarti,
      trust:"Trusted by 50+ companies worldwide",
      linkTo:"/theImpactLeague"
    },
    {
      id: 2,
      name: "Cause Branding",
      detail:
        "Involve a community of millions of healthy people with your social good work. Join the 30+ companies who contribute their csr to match the steps of our community.",
      img: images.offering2,
      logo1:images.hdfcBank,
      logo2:images.heroMotor,
      logo3:images.apollo,
      logo4:images.aarti,
      trust:"Trusted by 30+ companies",
      linkTo:"/causeBranding"
    },
    {
      id: 3,
      name: "Marketing Brands",
      detail:
        "Engage to a community of 300K+ monthly active users by offering them exciting rewards and discounts. On Impact, our users walk or jog for a cause they care, and earn Impact-coins. They use these coins to unlock exclusive deals and discounts from the country's best brands.",
      img: images.offering3,
      logo1:images.boat,
      logo2:images.eatAnytime,
      logo3:images.gizmore,
      logo4:images.maxprotein,
      trust:"Trusted by 100+ brands",
      linkTo: "/marketingBrands"
    },
  ];

  return (
    <div>
      <OfferingCard data={data[0]} onButtonClick={togglePopup} />
      <OfferingCard data={data[1]} onButtonClick={togglePopup} />
      <OfferingCard data={data[2]} onButtonClick={togglePopup} />
      <OfferingLast />
      <Popup showPopup={showPopup} togglePopup={togglePopup} />
    </div>
  );
}

export default Offerings;
